var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('layout-report-step', {
    staticClass: "autoHypen",
    attrs: {
      "isDone": _vm.isDone,
      "title": _vm.header.title,
      "description": _vm.header.description
    }
  }, [_c('v-card', {
    staticClass: "pt-4",
    staticStyle: {
      "min-height": "calc(100vh - 360px)"
    },
    attrs: {
      "flat": "",
      "max-width": "500"
    }
  }, [_c('v-card-text', {
    staticClass: "pb-0"
  }, [_c('form', [_c('v-radio-group', {
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', [_vm._v(_vm._s(_vm.$t("report.reponsibleParty.content.title")))])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.isLiabilityDamage.isLiabilityDamage,
      callback: function callback($$v) {
        _vm.$set(_vm.isLiabilityDamage, "isLiabilityDamage", $$v);
      },
      expression: "isLiabilityDamage.isLiabilityDamage"
    }
  }, [_c('v-radio', {
    attrs: {
      "value": false,
      "label": _vm.$t('report.reponsibleParty.content.driver'),
      "data-test-driver": ""
    }
  }), _c('v-radio', {
    attrs: {
      "value": true,
      "label": _vm.$t('report.reponsibleParty.content.other'),
      "data-test-other": ""
    }
  })], 1)], 1)])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }